// src/components/modals/SogniAuthModals.js
import React, { useState } from 'react';
import { redirectToAuth } from '../../utils/auth';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';

const SogniAuthModals = ({
  showSogniLoginModal,
  setShowSogniLoginModal,
  sogniUsername,
  setSogniUsername,
  sogniPassword,
  setSogniPassword,
  sogniErrorMessage,
  handleSogniLoginSubmit,
  sogniClientReady,
  accountCreated,

  // Reauth changes
  showSogniReauthModal,
  handleSogniReauthSubmit,
  sogniReauthPassword,
  setSogniReauthPassword,
  handleSogniReauthCancel
}) => {
  // NEW: local state to track if the login button is currently "Loading..."
  const [loginLoading, setLoginLoading] = useState(false);

  // We wrap the user's handleSogniLoginSubmit in our own so we can set loading state
  const onLoginFormSubmit = async (e) => {
    e.preventDefault();
    redirectToAuth('login');
  };

  // We also moved the “Sign up” functionality into this modal.
  const encodedRedirect = encodeURIComponent('https://nft.sogni.ai/callback');
  const signupUrl = `https://app.sogni.ai/signup/?redirect=${encodedRedirect}&authMode=cookies&ts=${Date.now()}`;

  const handleSignupClick = (e) => {
    e.preventDefault();
    window.location.href = signupUrl;
  };

  return (
    <>
      {/* Login Modal */}
      <Modal
        show={showSogniLoginModal}
        onHide={() => setShowSogniLoginModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Sogni Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={onLoginFormSubmit}>
            {/* If they just created an account, display a short note. */}
            {accountCreated && (
              <div
                style={{
                  marginBottom: '15px',
                  color: 'white',
                  fontFamily: 'monospace',
                  fontSize: '14px'
                }}
              >
                <strong>Congrats on signing up!</strong>
                <br />
                Please log in below to finalize your Sogni account and mint your GPU Worker NFT.
              </div>
            )}

            <Form.Group controlId="sogniUsername">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                value={sogniUsername}
                onChange={(e) => setSogniUsername(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="sogniPassword" className="mt-2">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                value={sogniPassword}
                onChange={(e) => setSogniPassword(e.target.value)}
              />
            </Form.Group>
            {sogniErrorMessage && (
              <p style={{ color: 'red', marginTop: '10px' }}>{sogniErrorMessage}</p>
            )}

            {/* Updated button to show spinner while logging in */}
            <Button
              variant="primary"
              type="submit"
              className="mt-3"
              disabled={!sogniClientReady || loginLoading}
            >
              {loginLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{' '}
                  Logging in...
                </>
              ) : sogniClientReady ? (
                'Login'
              ) : (
                'Sogni Client Initializing...'
              )}
            </Button>

            {/* NEW: Sign up link at bottom right */}
            <div className="d-flex justify-content-end mt-2">
              <Button
                variant="link"
                style={{ textDecoration: 'underline', color: '#39ff14' }}
                onClick={handleSignupClick}
              >
                Sign up
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Reauth Modal */}
      <Modal show={showSogniReauthModal} onHide={handleSogniReauthCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSogniReauthSubmit}>
            {/* Username is fixed; show as read-only context */}
            {sogniUsername && (
              <div style={{ marginBottom: '6px', color: '#aaa', fontSize: '0.9rem' }}>
                User: <strong>@{sogniUsername}</strong>
              </div>
            )}
            <Form.Group controlId="sogniReauthPassword" className="mt-2">
              <Form.Label>Enter password to confirm</Form.Label>
              <Form.Control
                type="password"
                value={sogniReauthPassword}
                onChange={(e) => setSogniReauthPassword(e.target.value)}
              />
            </Form.Group>
            {/* Show any error messages here for consistency */}
            {sogniErrorMessage && (
              <p style={{ color: 'red', marginTop: '10px' }}>{sogniErrorMessage}</p>
            )}
            <Button
              variant="primary"
              type="submit"
              className="mt-3"
              disabled={!sogniClientReady}
            >
              {sogniClientReady ? 'Confirm' : 'Sogni Client Initializing...'}
            </Button>
            <Button variant="secondary" className="mt-3 ms-2" onClick={handleSogniReauthCancel}>
              Cancel
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SogniAuthModals;
